'use strict';
import React from 'react';
import flux from 'utils/flux';
import { Link } from 'react-router';
import classnames from 'classnames';
import SubmissionLink from './submissionLink';
import HeaderDropdown from './headerDropdown';
import HeaderLanguageSelection from './headerLanguageSelection';

var HeaderAuthenticated = React.createClass({

    displayName: 'HeaderAuthenticated',

    contextTypes: {
        router: React.PropTypes.func.isRequired
    },

    propTypes: {
        activeBasketId: React.PropTypes.string
    },

    getInitialState() {
        return {
            dropdownIsOpen: false
        };
    },

    handleDropdownClick() {
        this.setState({
            dropdownIsOpen: false
        });
    },

    handleLicenseLinkClick( e ) {
        const basketStore = flux.getStore('basket');

        // prevent browsing to licensing before they actually loaded
        if ( !basketStore.state.firstload ) {
            e.preventDefault();
        }
    },

    handleBasketLinkClick( e ) {
        const basketStore = flux.getStore('basket');

        // prevent browsing to the baskets before they actually loaded
        if ( !basketStore.state.firstload ) {
            e.preventDefault();
        }
    },

    toggleOffcanvas(e) {
        e.preventDefault();
        flux.getStore('app').toggleOffcanvas();
    },

    scrollToTop() {
        window.scrollTo(0, 0);
    },
    logout(e) {
        e.preventDefault();
        flux.getActions('app').logout();
        this.context.router.transitionTo('login');
    },

    showExcelSearch(e) {
        e.preventDefault();
        flux.getActions('modals').openModal('ExcelSearch');
    },


    showRegister(e) {
        e.preventDefault();
        flux.getActions('modals').openModal('Register');
    },
    clearFilters(e) {
        e.preventDefault();
        flux.getActions('media').clearQuery();
        this.context.router.transitionTo('landing-page');
    },

    render() {
        const { config } = flux.getStore('app').getState();
        const { licensing, allowSubmissions, userGuide, disableChangePassword, showHelp, helpLink, termsLink, showImprint,
            showTerms, showAccountHeaderNav, showUserGuide, showPrivacy, disableAccountDetails, disableLogout } = config.toJS();
        const { accountEditable, passwordEditable, mediaboxRights, samlLogin, noneLogin, excel_rights } = flux.getStore('app').getState();
        const basketStore = flux.getStore('basket');
        const activeBasketId = this.props.activeBasketId;

        return (
            <div className={classnames( 'header--inner', { 'header--has-submission-button': allowSubmissions } )}>
                {
                    !this.context.router.getCurrentPath().includes("shared") &&
                    <Link to="landing-page" className="header__logo" onClick={this.clearFilters} >
                        <div className="logo__image"/>
                        <div className="logo__divider"></div>
                        <div className="logo__title">
                            <h4 onClick={this.scrollToTop}>{flux.t('header_title')}</h4>
                        </div>
                    </Link>
                }

                {
                    this.context.router.getCurrentPath().includes("shared") &&
                    <div className="header__logo">
                        <div className="logo__image"/>
                        <div className="logo__divider"></div>
                        <div className="logo__title">
                            <h4 onClick={this.scrollToTop}>{flux.t('header_title')}</h4>
                        </div>
                    </div>
                }

                {allowSubmissions && <div className="awards-button__wrapper"><SubmissionLink /></div>}

                <ul className="header__menu">
                    {
                      licensing && <li className="menu__item">
                        <Link
                            to={(basketStore.isLoading() || !activeBasketId) ? 'licensing' : 'singleLicensing'}
                            params={{ id: activeBasketId }} >
                            {flux.t('nav_request_licence')}
                            <i className="play"></i>
                        </Link>
                     </li>
                    }

                    {excel_rights && (Array.isArray(excel_rights) ? excel_rights.length : 0) > 0 &&
                        <li>
                            <a href={window.location.href} onClick={ this.showExcelSearch }>
                                <i className="play-linkicon"></i>
                                { flux.t('excel_search') }
                            </a>
                        </li>
                    }

                    <li className="menu__item">
                        <Link
                            to={(basketStore.isLoading() || !activeBasketId) ? 'basket' : 'singleBasket'}
                            params={{ id: activeBasketId }} >
                            <i className="play-linkicon"></i>
                            {flux.t('basket_selection')}
                        </Link>
                    </li>

                    {
                      showImprint &&
                        <li className="menu__item no__icon">
                            <a href="/#/imprint" target="_blank">
                                {flux.t('imprint')}
                            </a>
                        </li>
                    }
                    {
                        ((showHelp === undefined || !!showHelp) && !helpLink) &&
                        <li className="menu__item no__icon">
                            <Link to="help" className="item__help">
                                {flux.t('nav_help_me')}
                            </Link>
                        </li>
                    }
                    {
                      ((showHelp === undefined || !!showHelp) && helpLink) &&
                        <li className="menu__item no__icon">
                            <a className="item__help" href={helpLink} target="_blank">
                                {flux.t('nav_help_me')}
                            </a>
                        </li>
                    }
                    {
                        (showAccountHeaderNav === undefined || !!showAccountHeaderNav) &&
                        <HeaderDropdown
                            label={flux.t('account_header_nav')}
                            isOpen={this.state.dropdownIsOpen}>
                            <ul>
                                {
                                    (showUserGuide === undefined || !!showUserGuide) &&
                                    <li>
                                        <i className="play "></i>
                                        <a href={userGuide} target="_blank">{flux.t('quick_start_guide')}</a>
                                    </li>
                                }
                                {false !== accountEditable && !disableAccountDetails &&
                                <li><i className="play "></i><Link to="accountDetails">{flux.t('account_details')}</Link></li>
                                }
                                {false !== passwordEditable && !disableChangePassword &&
                                <li><i className="play "></i><Link to="accountPassword">{flux.t('account_password_change_head')}</Link></li>
                                }
                                {
                                    !termsLink && (showTerms === undefined || !!showTerms) &&
                                    <li><i className="play "></i><a href="/#/terms-of-use" target="_blank">{flux.t('terms-of-use')}</a></li>
                                }
                                {
                                    termsLink &&
                                    <li><i className="play "></i><a href={termsLink} target="_blank">{flux.t('terms-of-use')}</a></li>
                                }
                                {
                                    showPrivacy &&
                                    <li><i className="play "></i><a href="/#/privacy-policy" target="_blank">{flux.t('privacy-policy')}</a></li>
                                }
                                {(mediaboxRights === 1 && !(samlLogin || noneLogin)) &&
                                    <li>
                                        <i className="play "></i>
                                        <a href={window.location.href} onClick={ this.showRegister }>
                                            { flux.t('sign_up_new_user') }
                                        </a>
                                    </li>
                                }
                            </ul>
                        </HeaderDropdown>
                    }
                    {
                        <HeaderLanguageSelection />
                    }
                    { !disableLogout &&
                        <li className="menu__item">
                            <a href="#" onClick={this.logout} title="Logout">
                                <i className="log-out logout__icon "></i>
                                {flux.t('navigate_logout')}
                            </a>
                        </li>
                    }
                </ul>

                <a href className="header__offcanvas" onClick={this.toggleOffcanvas}>
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewport="0 0 25 25" viewBox="0 0 25 25">
                        <path d="M1,11h22v3H1V11z"></path>
                        <path d="M1,17h22v3H1V17z"></path>
                        <path d="M1,5h22v3H1V5z"></path>
                    </svg>
                </a>

            </div>
        );
    }
});

module.exports = HeaderAuthenticated;



// WEBPACK FOOTER //
// ./app/components/header/headerAuthenticated.jsx